import { atom, selector } from "recoil";

import { AlarmsType } from "@types";

export const alertTogglePleaseLoginState = atom<boolean>({
  key: "alertTogglePleaseLogin",
  default: false,
});

export const alertToggleAlamCompletedState = atom<boolean>({
  key: "alertToggleAlamCompleted",
  default: false,
});

export const alarmsDataState = atom<AlarmsType | null>({
  key: "alarmsData",
  default: null,
});

export const isLoginState = selector<boolean>({
  key: "isLogin",
  get: ({ get }) => get(alarmsDataState) !== null,
});

export const sheetToggleVaccineState = atom<boolean>({
  key: "vaccineSheetToggle",
  default: false,
});

export const sheetToggleSortState = atom<boolean>({
  key: "sortSheetToggle",
  default: false,
});

export const sheetToggleIsolationState = atom<boolean>({
  key: "isolationSheetToggle",
  default: false,
});

export const modalToggleIsmsState = atom<boolean>({
  key: "modalToggleIsms",
  default: false,
});

export const modalToggleDetailsState = atom<boolean>({
  key: "modalToggleDetails",
  default: false,
});

export const modalToggleTermsOfServiceState = atom<boolean>({
  key: "modalToggleTermsOfService",
  default: false,
});

export const toggleNetworkErrorState = atom<boolean>({
  key: "toggleNetworkError",
  default: false,
});
